export default __webpack_public_path__ + "1bc5568b233d6c7d2c2ce4de5a61f3fe.png";